import store from '@/store';
import requestAPI from '../requestBeApi';

const assessmentsRequestService = {
  async getRequests({
    self,
    filter,
    reloadExisting,
  }: {
    self: any;
    filter: string;
    reloadExisting?: boolean;
  }): Promise<void> {
    if (store.state.allProjectsDelivered && !reloadExisting) return;

    store.commit('setProjectsRequestPending', true);

    const currentListLength = store.state.eventsNumber.projects[filter];
    const defaultCall = !reloadExisting;
    let page: number, perPage: number;

    if (defaultCall) {
      perPage = 10;
      page = store.state.nextProjectsPageNum;
    } else if (reloadExisting) {
      perPage = currentListLength + 1;
      page = 1;

      store.commit('cleanProjects');
    }

    const url = this.getRequestUrl(filter, page, perPage);

    if (defaultCall) store.commit('setNextProjectsPageNum', (store.state.nextProjectsPageNum += 1));
    const response = await requestAPI({ url, method: 'GET' });

    if (response.ok) {
      this.parseProjectsData(response);
    } else {
      if (response.status !== 401) {
        self.$message({
          message: self.$t('someErrorOccurred'),
          type: 'error',
        });
      }
    }

    store.commit('setProjectsRequestPending', false);
  },

  getRequestUrl(filter: string, page: number, perPage: number): string {
    const userRole = store.state.userRole;
    let filterToSend: string;

    if (userRole === 'assessor') {
      filterToSend = this.prepareFilterForAssessor(filter);
    } else if (userRole === 'client') {
      filterToSend = this.prepareFilterForClient(filter);
    }

    const base = `/api/v1/${userRole}s/me/assessment-requests`;
    const params = `?${filterToSend}&page=${page}&per_page=${perPage}&order[updated_at]=DESC`;

    return `${base}${params}`;
  },

  prepareFilterForAssessor(filter: string): string {
    let filterToSend: string;

    if (filter === 'requests') {
      filterToSend =
        'status[]=accepted&status[]=pending&assessment_request_assessors.status[]=invited&assessment_request_assessors.status[]=accepted';
    } else if (filter === 'ongoing') {
      filterToSend =
        'status[]=confirmed&assessment_request_assessors.status[]=confirmed&assessment_request_assessors.status[]=co_assessor_accepted';
    } else if (filter === 'completed') {
      filterToSend =
        'status[]=completed&status[]=cancelled&status[]=expired&status[]=invoices_sent';
    } else {
      // fallback is for 'requests'
      filterToSend =
        'status[]=accepted&status[]=pending&assessment_request_assessors.status[]=invited&assessment_request_assessors.status[]=accepted';
    }

    return filterToSend;
  },

  prepareFilterForClient(filter: string): string {
    let filterToSend: string;

    if (filter === 'requests') {
      filterToSend =
        'status[]=draft&status[]=new&status[]=assessors_matched&status[]=pending&status[]=accepted&status[]=interested&status[]=declined';
    } else if (filter === 'ongoing') {
      filterToSend = 'status[]=confirmed';
    } else if (filter === 'completed') {
      filterToSend =
        'status[]=completed&status[]=cancelled&status[]=expired&status[]=invoices_sent';
    } else {
      // fallback is for 'requests'
      filterToSend =
        'status[]=draft&status[]=new&status[]=assessors_matched&status[]=pending&status[]=accepted&status[]=interested&status[]=declined';
    }

    return filterToSend;
  },

  async parseProjectsData(response: { json: () => any }): Promise<void> {
    const data = await response.json();
    const isAssessor: boolean = store.state.userRole === 'assessor';

    const projects = data.map(
      (project: {
        client: { company_name: unknown; company_image: unknown };
        name: unknown;
        status: unknown;
        assessor_status: unknown;
        percentage: unknown;
        company_image: unknown;
        function: unknown;
        id: unknown;
        deadline: unknown;
        co_assessors: unknown;
      }) => {
        return {
          company: isAssessor ? project.client.company_name : project.name,
          status: project.status,
          assessorStatus: project.assessor_status,
          percentageProgress: project.percentage,
          imgUrl: isAssessor ? project.client.company_image : project.company_image,
          position: project.function,
          id: project.id,
          deadline: project.deadline,
          coAssessors: project.co_assessors,
        };
      },
    );

    store.commit('setProjects', projects);
  },
  async getNumberOfProjects(self: any): Promise<void> {
    const resp = await requestAPI({
      method: 'GET',
      url: `/api/v1/clients/me/assessment-requests`,
    });
    if (resp.ok) {
      const data = await resp.json();
      const numberOfOverallProjects = data.length;
      store.commit('setOverallNumberOfProjects', numberOfOverallProjects);
    } else if (resp.status !== 401) self.$message.error(self.$t('someErrorOccurred'));
  },
};

export default assessmentsRequestService;
